export const QUERY_KEY_COMMENT_LIST = 'comment-list'

export const COMMENT_LIST_QUERY_KEY = (filters: unknown[]) => [
  QUERY_KEY_COMMENT_LIST,
  ...filters,
]

export const COMMENT_STATUSES = {
  open: 'Open',
  resolved: 'Resolved',
} as const

export const COMMENT_ACTIONS = {
  actionable: 'Action',
  not_actionable: 'No action',
} as const

export const REVIEW_STATUSES = {
  reviewed: 'Reviewed',
  not_reviewed: 'Not Reviewed',
} as const

export const COMMENT_FILTERS_STORAGE_KEY = 'commentFiltersFromDashboard'
